import * as React from "react";

export class SuperBannerItem extends React.Component<{
    width?: number
    modifier?: string
}, {}>
{
    render() {
        let cls: string = "rj-superbanner__item" + (this.props.modifier ? ` ${this.props.modifier}` : "");
        let dataUat: string = "superbanner-item" + (this.props.modifier ? `-${this.props.modifier}` : "");

        const styles = this.props.width ? { width: `${this.props.width}px` } : undefined;

        return (
            <div style={styles} className={cls} data-uat={dataUat}>{this.props.children}</div>
        );
    }
}